module.exports = __webpack_public_path__ + "media/landing_page/icon-circle-230c60a9.png";